import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import TaskCard from "@/components/TaskCard";
import TaskDetailDrawer from "@/components/TaskDetailDrawer";
import CreateTaskDialog from "@/components/CreateTaskDialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { STATUS_META } from "@/lib/format";
import { Plus, Search } from "lucide-react";

export default function MyTasks() {
  const [tasks, setTasks] = useState([]);
  const [q, setQ] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [openId, setOpenId] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [createOpen, setCreateOpen] = useState(false);

  const load = () => api.get("/tasks", { params: { scope: "mine" } }).then((r) => setTasks(r.data.filter((t) => t.assignee_user_id)));
  useEffect(() => { load(); }, []);
  const open = (id) => { setOpenId(id); setDrawerOpen(true); };

  const mine = tasks.filter((t) => {
    const okQ = !q || t.title.toLowerCase().includes(q.toLowerCase());
    const okS = statusFilter === "all" || t.status === statusFilter;
    return okQ && okS;
  });

  return (
    <div>
      <div className="flex items-center justify-between gap-3 mb-6 flex-wrap">
        <div>
          <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-900">Tugas Saya</h1>
          <p className="text-slate-500 text-sm">Semua tugas yang ditugaskan kepada Anda</p>
        </div>
        <Button onClick={() => setCreateOpen(true)} data-testid="create-task-btn" className="bg-indigo-600 hover:bg-indigo-700"><Plus className="h-4 w-4 mr-1.5" />Buat Tugas</Button>
      </div>

      <div className="flex gap-3 mb-5 flex-wrap">
        <div className="relative flex-1 min-w-[200px]">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cari tugas..." className="pl-9" data-testid="task-search" />
        </div>
        <Select value={statusFilter} onValueChange={setStatusFilter}>
          <SelectTrigger className="w-52" data-testid="status-filter"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Semua Status</SelectItem>
            {Object.entries(STATUS_META).map(([k, v]) => <SelectItem key={k} value={k}>{v.label}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>

      {mine.length === 0 ? (
        <div className="text-center py-16 text-slate-400">Tidak ada tugas.</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {mine.map((t) => <TaskCard key={t.id} task={t} onClick={() => open(t.id)} />)}
        </div>
      )}

      <TaskDetailDrawer taskId={openId} open={drawerOpen} onOpenChange={setDrawerOpen} onChanged={load} />
      <CreateTaskDialog open={createOpen} onOpenChange={setCreateOpen} onDone={load} />
    </div>
  );
}
